module.exports = __webpack_public_path__ + "img/ch2.42a6ab67.jpg";